export default __webpack_public_path__ + "static/media/cinamon1.81ce92f4.png";